import { Link, useParams } from 'react-router-dom';
import { MenuExperience } from '@restaurant-menu-saas/menu-renderer';
import { api } from '../../api/client.js';
import { useApiQuery } from '../../api/useApiQuery.js';
import { MenuQrCode } from '../../components/MenuQrCode.jsx';
import { getPublicMenuUrl } from '../../utils/publicMenuUrl.js';

// Renders the draft with the EXACT same component the public site uses
// (spec §12/§33) — so what the admin sees here is what publishing will
// produce, not a second, potentially-drifted preview implementation.
export function MenuPreviewPage() {
  const { menuId } = useParams();
  const { data: tree, loading, error, reload } = useApiQuery(() => api.get(`/api/menus/${menuId}/publish/preview`), [menuId]);

  return (
    <div className="menu-preview-page lp-theme">
      <div className="preview-toolbar">
        <Link className="back-link" to={`/menus/${menuId}`}>← Back to editor</Link>
        <div className="preview-toolbar__actions">
          {tree?.menu?.isPublished && <MenuQrCode menuName={tree.menu.name} menuSlug={tree.menu.slug} menuUrl={getPublicMenuUrl(tree.tenant.slug, tree.menu.slug)} />}
          <button type="button" className="btn btn-sm" onClick={reload} disabled={loading} aria-busy={loading || undefined}>
            {loading ? 'Refreshing…' : 'Refresh preview'}
          </button>
        </div>
      </div>
      {loading && !tree && <span className="spinner" aria-label="Loading" style={{ margin: 20 }} />}
      {error && <p className="field-error" style={{ margin: 20 }}>{error.message}</p>}
      {tree && <div className="menu-preview-frame"><MenuExperience menuData={tree} /></div>}
    </div>
  );
}
